import {Component, OnInit} from '@angular/core';
import {FieldConfig, FieldType} from 'src/app/shared/components/dynamic-forms-components/field.interface';

import {StepperOrientation} from "@angular/cdk/stepper";
import {Observable} from "rxjs";
import {BreakpointObserver} from "@angular/cdk/layout";
import {map} from "rxjs/operators";


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})

export class RegisterComponent implements OnInit {
  title: string;
  fields: FieldConfig[]

  hide: boolean = true;
  hide1: boolean = true;
  progress: number;
  steps: any;
  registerAs: string = 'citizen';

  timer: any;

  stepperOrientation: Observable<StepperOrientation>;
  isLargeScreen: Observable<boolean>

  constructor(
    breakpointObserver: BreakpointObserver,
  ) {
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({matches}) => (matches ? 'horizontal' : 'vertical')));
    this.isLargeScreen = breakpointObserver
      .observe('(min-width: 1400px)')
      .pipe(map(({matches}) => (matches)));

  }

  ngOnInit(): void {

  }


  setRegistrationType(type: string) {
    this.registerAs = type;
  }


}
